<section class="container-fluild">
    <div class="forgot-password">

        <!-- SEND EMAIL -->
        <ng-container>
            <h1 class="fogot-password-title">{{'login.forgot_password' | translate}}</h1>
            <form nz-form [formGroup]="validateEmailForm" class="forgot-password-form" (ngSubmit)="onSubmitEmail()">
                <nz-form-item>
                    <nz-form-label class="form-label" [nzSm]="24" nzFor="userName">{{'login.username' | translate}}
                    </nz-form-label>
                    <nz-form-control nzErrorTip="{{'login.username_required' | translate}}" class="common-input">
                        <input id="userName" type="text" nz-input formControlName="userName"
                            placeholder="{{'login.username' | translate}}" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label class="form-label" [nzSm]="24" nzFor="email">Email</nz-form-label>
                    <nz-form-control [nzErrorTip]="emailErrorTpl" class="common-input">
                        <input id="email" type="email" nz-input formControlName="email" placeholder="Email" />
                        <ng-template #emailErrorTpl let-control>
                            @if (control.hasError('email')) {
                                {{'login.invalid_email' | translate}}
                            }
                            @if (control.hasError('required')) {
                                {{'login.email_required' | translate}}
                            }
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
                <div nz-col [nzSpan]="24" class="remembered-password">
                    <a [routerLink]="'/auth/login'" class="link">{{'login.remembered_password' | translate}}?</a>
                </div>
            </form>
        </ng-container>
    </div>
</section>